import React from 'react';
import { Redirect, Link } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import utils from '../Utils';
import Pagination from './slider/Pagination';







import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/intro.css'

import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';
import { Button } from '@material-ui/core';

// const VirtualizeSwipeableViews = virtualize(SwipeableViews);


const STEP_TEST = 'test'
const STEP_RESULT = 'result'
class Intro extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      step: STEP_TEST,
      result: 0,
      redirectToLogin: false,
      sliderIndex: 0,
      answers: [],
      slides: [
        { t: '', d:'', img: '/images/slider/art11.jpg'},
        { t: '', d:'', img: '/images/slider/art1.jpg'},
        { t: '', d:'', img: '/images/slider/art2.jpg'},
        { t: '', d:'', img: '/images/slider/art3.jpg'},
        { t: '', d:'', img: '/images/slider/art4.jpg'},
        { t: '', d:'', img: '/images/slider/art5.jpg'},
        { t: '', d:'', img: '/images/slider/art6.jpg'},
        { t: '', d:'', img: '/images/slider/art7.jpg'},
        { t: '', d:'', img: '/images/slider/art8.jpg'},
        { t: '', d:'', img: '/images/slider/art9.jpg'},
        { t: '', d:'', img: '/images/slider/art10.jpg'},
      ]
    }
  }



  renderSlides = () => {
    return this.state.slides.map((slide, index) => {
      return (
        <div class='slide'>
          <img src={slide.img} alt='اسلاید' />
          <div class="title"> {slide.t}</div>
          <div class="desc"> {slide.d}</div>
        </div>
      )
    })
  }

  handleChangeIndex = index => {
    this.setState({ sliderIndex: index })
  }

  nextSlide = () => {
    if (this.state.sliderIndex == 10)
      return this.props.setIntroShow(true)
    this.setState({ sliderIndex: this.state.sliderIndex + 1 })
  }

  prevSlide = () => {
    if (this.state.sliderIndex == 0)
      return
    this.setState({ sliderIndex: this.state.sliderIndex - 1 })
  }

  resetState = () => {
    this.setState({
      step: STEP_TEST,
      result: 0,
      sliderIndex: 0,
      answers: [],
    })
  }

  render() {
    return (
        <div class="intro-root">

                <SwipeableViews slideStyle={{ height: '100%' }} containerStyle={{ height: '100%' }}
                  className='slider-root' index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} axis="x-reverse"
                  disabled={false}>
                  {this.renderSlides()}
                </SwipeableViews>
              <div class='intro-footer'>
          <div class='prev-slide' onClick={this.prevSlide}>
            قبلی
                  <ChevronRightRoundedIcon />
            </div>
            <div class='slide-number'>
              <Pagination dots={11} index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} style={{ position: 'unset',}}/>
            </div>
          <div class='next-slide' onClick={this.nextSlide}>
            بعدی
              <ChevronLeftRoundedIcon></ChevronLeftRoundedIcon>
                </div>
              </div>

        </div>
    )
  }

}

export default Intro